export default [
    {
        path: 'broadcast',
        name: 'marketing_broadcast',
        meta: {
            access: ['MESSAGE_BROADCAST_PLAN'],
            title: 'marketing_broadcast',
            icon: 'icon-guangbo',
            notPageView: true,
        },
        redirect: { name: 'marketing_broadcast_list' },
        component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/broadcast.vue'),
        children: [
            {
                path: 'list',
                name: 'marketing_broadcast_list',
                meta: {
                    hideInMenu: true,
                    access: ['MESSAGE_BROADCAST_PLAN'],
                    title: 'marketing_broadcast',
                    icon: 'icon-guangbo',
                },
                component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/list/index.vue'),
            },
            {
                path: 'plan/:id*',
                name: 'marketing_broadcast_plan',
                meta: {
                    hideInMenu: true,
                    access: ['MESSAGE_BROADCAST_PLAN'],
                    title: 'marketing_broadcast_plan',
                    icon: 'icon-guangbo',
                },
                component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/plan/index.vue'),
            },
            {
                path: 'create/:id*',
                name: 'marketing_broadcast_create',
                meta: {
                    hideInMenu: true,
                    access: ['MESSAGE_BROADCAST_PLAN'],
                    title: 'marketing_broadcast_create',
                    icon: 'icon-guangbo',
                },
                props: (route:any) => {
                    return {
                        ...route.query,
                    };
                },
                component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/create/index.vue'),
            },
        ],
    },
];
